"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var datetime_picker_popup_component_1 = require("./datetime-picker-popup.component");
var datetime_1 = require("./datetime");
var input_base_component_1 = require("../input-base/input-base.component");
var utilities_1 = require("../../utils/utilities");
var DateTimePickerComponent = (function (_super) {
    __extends(DateTimePickerComponent, _super);
    function DateTimePickerComponent(ele, resolver, viewContainerRef, parent) {
        var _this = _super.call(this, ele) || this;
        _this.ele = ele;
        _this.resolver = resolver;
        _this.viewContainerRef = viewContainerRef;
        _this.parent = parent;
        _this.dateFormat = 'MM/DD/YYYY';
        _this.dateOnly = true;
        _this.hour = 23;
        _this.minute = 59;
        _this.closeOnSelect = true;
        _this.valueChanged = function (date) {
            if (typeof date === 'string' && date) {
                _this.el['dateValue'] = _this.getDate(date);
            }
            else if (typeof date === 'object') {
                _this.el['dateValue'] = date;
            }
            else if (typeof date === 'undefined') {
                _this.el['dateValue'] = null;
            }
            var formattedDate = _this.getFormattedDateStr();
            if (!moment(_this.control.value).isSame(formattedDate))
                _this.control.setValue(_this.getFormattedDateStr());
        };
        _this.hideDatetimePicker = function (event) {
            if (_this.componentRef) {
                if (event &&
                    event.type === 'click' &&
                    event.target !== _this.el &&
                    !_this.elementIn(event.target, _this.datetimePickerEl)) {
                    _this.componentRef.destroy();
                    _this.componentRef = undefined;
                }
                else if (!event) {
                    _this.componentRef.destroy();
                    _this.componentRef = undefined;
                }
            }
        };
        _this.keyEventListener = function (e) {
            if (e.keyCode === 27) {
                _this.hideDatetimePicker();
            }
        };
        return _this;
    }
    DateTimePickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onInit();
        this.el = this.viewContainerRef.element.nativeElement
            .getElementsByTagName('input')[0];
        if (utilities_1.iOS()) {
            this.inputType = 'date';
            return;
        }
        var wrapper = document.createElement('div');
        wrapper.className = 'ng2-datetime-picker';
        wrapper.style.position = 'relative';
        this.el.parentElement.insertBefore(wrapper, this.el.nextSibling);
        wrapper.appendChild(this.el);
        document.body.addEventListener('click', this.hideDatetimePicker);
        this.el.addEventListener('keyup', this.keyEventListener);
        setTimeout(function () {
            _this.valueChanged(_this.el.value);
        });
    };
    DateTimePickerComponent.prototype.addValidators = function () { };
    DateTimePickerComponent.prototype.ngOnChanges = function (changes) {
        var newNgModel;
        if (changes && changes['ngModel']) {
            newNgModel = changes['ngModel'].currentValue;
        }
        this.triggerChange(newNgModel);
    };
    DateTimePickerComponent.prototype.triggerChange = function (newNgModel) {
        if (this.ctrl) {
            this.ctrl.markAsDirty();
        }
        if (typeof newNgModel === 'string') {
            this.el['dateValue'] = this.getDate(newNgModel);
        }
        else if (newNgModel instanceof Date) {
            this.el['dateValue'] = newNgModel;
        }
    };
    DateTimePickerComponent.prototype.ngOnDestroy = function () {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        document.body.removeEventListener('click', this.hideDatetimePicker);
        this.el.removeEventListener('keyup', this.keyEventListener);
        if (this.datetimePickerEl) {
            this.datetimePickerEl.removeEventListener('keyup', this.keyEventListener);
        }
    };
    DateTimePickerComponent.prototype.preventDefault = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    DateTimePickerComponent.prototype.showDatetimePicker = function (event) {
        var _this = this;
        if (this.componentRef || utilities_1.iOS()) {
            return;
        }
        setTimeout(function () {
            var factory = _this.resolver.resolveComponentFactory(datetime_picker_popup_component_1.DateTimePickerPopupComponent);
            _this.componentRef = _this.viewContainerRef.createComponent(factory);
            _this.datetimePickerEl = _this.componentRef.location.nativeElement;
            _this.datetimePickerEl.addEventListener('keyup', _this.keyEventListener);
            var component = _this.componentRef.instance;
            component.initDateTime(_this.el['dateValue']);
            component.dateOnly = _this.dateOnly;
            _this.styleDatetimePicker();
            component.changes.subscribe(_this.valueChanged);
            component.closing.subscribe(function () {
                return _this.closeOnSelect !== false && _this.hideDatetimePicker();
            });
        }, 10);
    };
    DateTimePickerComponent.prototype.elementIn = function (el, containerEl) {
        while (el = el.parentNode) {
            if (el === containerEl)
                return true;
        }
        return false;
    };
    DateTimePickerComponent.prototype.styleDatetimePicker = function () {
        var _this = this;
        var thisElBCR = this.el.getBoundingClientRect();
        this.datetimePickerEl.style.width = thisElBCR.width + 'px';
        this.datetimePickerEl.style.position = 'absolute';
        this.datetimePickerEl.style.zIndex = '1000';
        this.datetimePickerEl.style.left = '42px';
        this.datetimePickerEl.style.transition = 'height 0.3s ease-in';
        setTimeout(function () {
            var thisElBcr = _this.el.getBoundingClientRect();
            var datetimePickerElBcr = _this.datetimePickerEl.getBoundingClientRect();
            if (thisElBcr.bottom + datetimePickerElBcr.height > window.innerHeight) {
                _this.datetimePickerEl.style.bottom = '58px';
            }
            else {
                _this.datetimePickerEl.style.top = thisElBcr.height + 'px';
            }
            _this.datetimePickerEl.style.visibility = 'visible';
        });
    };
    ;
    DateTimePickerComponent.prototype.getFormattedDateStr = function () {
        if (this.el['dateValue']) {
            if (this.dateFormat) {
                return datetime_1.DateTime.momentFormatDate(this.el['dateValue'], this.dateFormat);
            }
            else {
                return datetime_1.DateTime.formatDate(this.el['dateValue'], this.dateOnly);
            }
        }
        else {
            return null;
        }
    };
    DateTimePickerComponent.prototype.getDate = function (arg) {
        var date;
        if (typeof arg === 'string') {
            if (this.dateFormat) {
                date = datetime_1.DateTime.momentParse(arg, this.dateFormat);
            }
            else {
                date = datetime_1.DateTime.parse(arg);
            }
        }
        else {
            date = arg;
        }
        return date;
    };
    return DateTimePickerComponent;
}(input_base_component_1.InputBase));
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], DateTimePickerComponent.prototype, "fg", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateTimePickerComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateTimePickerComponent.prototype, "field", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateTimePickerComponent.prototype, "label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateTimePickerComponent.prototype, "floatingLabel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateTimePickerComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateTimePickerComponent.prototype, "alt", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateTimePickerComponent.prototype, "required", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateTimePickerComponent.prototype, "value", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateTimePickerComponent.prototype, "dateFormat", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateTimePickerComponent.prototype, "dateOnly", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateTimePickerComponent.prototype, "hour", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateTimePickerComponent.prototype, "minute", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateTimePickerComponent.prototype, "closeOnSelect", void 0);
DateTimePickerComponent = __decorate([
    core_1.Component({
        selector: 'date-time-picker',
        template: "\n      <div class=\"input-group form-group\" [class.fc-alt]=\"alt\"><span class=\"input-group-addon\"><i class=\"zmdi zmdi-calendar\"></i></span><div class=\"dtp-container fg-line\" [class.disabled]=\"disabled\" [class.fg-toggled]=\"toggled\"><input class=\"form-control date-time-picker\" #i [type]=\"inputType\" placeholder=\"{{placeholder}}\" [formControl]=\"control\" [disabled]=\"disabled\" (focus)=\"onFocus(i); showDatetimePicker($event)\" (blur)=\"onBlur(i)\" (click)=\"preventDefault($event)\" (change)=\"valueChanged($event.target.value)\"></div></div>\n    ",
        providers: [datetime_1.DateTime],
    }),
    __param(3, core_1.Optional()), __param(3, core_1.Host()), __param(3, core_1.SkipSelf()),
    __metadata("design:paramtypes", [core_1.ElementRef,
        core_1.ComponentFactoryResolver,
        core_1.ViewContainerRef,
        forms_1.ControlContainer])
], DateTimePickerComponent);
exports.DateTimePickerComponent = DateTimePickerComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/forms/datetime-picker/date-time-picker.component.js
// module id = 69
// module chunks = 0